/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Allocations_Empty_State_DescriptionInputs */

const en_admin_dashboard_allocations_empty_state_description = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No new allocations starting or ending in the next 15 days.`)
};

const de_admin_dashboard_allocations_empty_state_description = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine neuen Zuweisungen, die in den nächsten 15 Tagen beginnen oder enden.`)
};

const es_admin_dashboard_allocations_empty_state_description = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay nuevas asignaciones que comiencen o terminen en los próximos 15 días.`)
};

const fr_admin_dashboard_allocations_empty_state_description = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune nouvelle attribution ne commence ou ne se termine dans les 15 prochains jours.`)
};

const nl_admin_dashboard_allocations_empty_state_description = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen nieuwe toewijzingen die starten of eindigen in de komende 15 dagen.`)
};

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */
const it_admin_dashboard_allocations_empty_state_description = en_admin_dashboard_allocations_empty_state_description;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_dashboard_allocations_empty_state_description = en_admin_dashboard_allocations_empty_state_description;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */
const pl_admin_dashboard_allocations_empty_state_description = en_admin_dashboard_allocations_empty_state_description;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */
const hu_admin_dashboard_allocations_empty_state_description = en_admin_dashboard_allocations_empty_state_description;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs) => LocalizedString} */
const ro_admin_dashboard_allocations_empty_state_description = en_admin_dashboard_allocations_empty_state_description;

/**
* | output |
* | --- |
* | "No new allocations starting or ending in the next 15 days." |
*
* @param {Admin_Dashboard_Allocations_Empty_State_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_allocations_empty_state_description = /** @type {((inputs?: Admin_Dashboard_Allocations_Empty_State_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Allocations_Empty_State_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "de") return de_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "es") return es_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "nl") return nl_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "it") return it_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_allocations_empty_state_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_allocations_empty_state_description(inputs)
	return ro_admin_dashboard_allocations_empty_state_description(inputs)
});
export { admin_dashboard_allocations_empty_state_description as "admin.dashboard.allocations_empty_state_description" }